import {
  getSavedRetailers,
  createSavedRetailers,
  updateSavedRetailers
} from '@/services/supplierRetailerRangeService'

const mutationTypes = {
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED',
  ERROR: 'ERROR'
}

const pendingFetchesBySupplier = new Map()

const state = {
  loading: false,
  savedRetailerIds: [],
  loadedSupplierId: null
}

const getters = {
  savedRetailerIds: (state) => state.savedRetailerIds
}

const toFetchOptions = (payload) => {
  if (typeof payload === 'object' && payload !== null) {
    return {
      supplierId: payload.supplierId,
      force: payload.force === true
    }
  }
  return {
    supplierId: payload,
    force: false
  }
}

const actions = {
  async fetchSavedRetailerList({ state, commit }, payload) {
    const { supplierId, force } = toFetchOptions(payload)
    if (!supplierId) {
      return []
    }

    if (!force && state.loadedSupplierId === supplierId) {
      return state.savedRetailerIds
    }

    if (pendingFetchesBySupplier.has(supplierId)) {
      return pendingFetchesBySupplier.get(supplierId)
    }

    commit(mutationTypes.FETCHING)
    const request = getSavedRetailers(supplierId)
      .then((ids) => {
        commit(mutationTypes.FETCHED, { ids, supplierId })
        return ids // important
      })
      .catch((e) => {
        console.error(e)
        commit(mutationTypes.ERROR)
        return [] // fallback
      })
      .finally(() => {
        pendingFetchesBySupplier.delete(supplierId)
      })

    pendingFetchesBySupplier.set(supplierId, request)
    return request
  },

  async saveRetailerList({ state, dispatch }, { supplierId, retailerIds }) {
    const isNew =
      state.loadedSupplierId !== supplierId ||
      state.savedRetailerIds.length === 0

    try {
      if (isNew) {
        await createSavedRetailers({ supplierId, retailerIds })
      } else {
        await updateSavedRetailers(supplierId, retailerIds)
      }
      await dispatch('fetchSavedRetailerList', { supplierId, force: true })
    } catch (e) {
      console.error(e)
    }
  }
}

const mutations = {
  [mutationTypes.FETCHING](state) {
    state.loading = true
  },
  [mutationTypes.FETCHED](state, payload) {
    state.savedRetailerIds = payload?.ids || []
    state.loadedSupplierId = payload?.supplierId || null
    state.loading = false
  },
  [mutationTypes.ERROR](state) {
    state.loading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
